<template>
  <div :style="{'height':height+'px'}" class="product-detail">
    <CreateNewOrder :yongLiaoList="yongLiaoList" @setModalState="setModalState" @editDesignInfo="editDesignInfo" :fieldData="fieldData"
                    :designInfo="designInfoTemp" :productModalshow="showDetailModal"/>
    <ChooseDaPei @confirmSelectZhuBuAction="confirmSelectZhuBuAction" @setSelectZhubuModal="setSelectZhubuModal"
                 @selectDapei="selectDapei" :list="design.collocationDesignList||[]" :modalShow="showDaPeiModal" />
    <ChooseZhubu @confirmSelectZhuBuAction="confirmSelectZhuBuAction" @setSelectZhubuModal="setSelectZhubuModal"
                 @selectZhubu="selectItem" :list="zhubuList" :modalShow="showDingzhiModal"/>
                 <!-- v-if="design.id" -->
    <div  style="padding-bottom:50px">
      <van-sticky offset-top="10">
        <van-icon @click="back" class="back-icon" name="arrow-left"/>
      </van-sticky>
      <van-swipe :autoplay="3000">
        <van-swipe-item :key="index" v-for="(item, index) in imgs">
          <img v-lazy="design[item]"/>
        </van-swipe-item>

      </van-swipe>
      <div class="info">
        <div class="title">{{ design.name }}</div>
        <div class="menfu">门幅：{{ design.zhuBuSpec }}</div>
        <div class="desc">
          <span v-if="design.zhuBuProductName">主布：{{ design.zhuBuProductName }}</span>&nbsp;&nbsp;
          <span v-if="design.peiBuProductName">配布：{{ design.peiBuProductName }}</span>
        </div>
      </div>
      <div class="img-detail">
        <img v-lazy="design.zhuBuDescriptionImageUrl"/>
      </div>
    </div>
    <!-- v-if="design.name" -->
    <van-goods-action >
<!--      <van-goods-action-icon v-show="customMade" icon="star-o" text="定制" @click="onDingzhi"/>-->
<!--      <van-goods-action-icon icon="flower-o" text="搭配" @click="onDaPei"/>-->
      <van-goods-action-icon v-show="customMade" icon="/roomicon/custom.png" text="定制" @click="onCustomDesign"/>
      <van-goods-action-icon icon="/roomicon/change_design.png" text="换款" @click="changeDesigns"/>
      <van-goods-action-icon icon="/roomicon/cart.png" text="前往购物车" @click="onClickIcon"/>
      <van-goods-action-button
          type="danger"
          text="加入购物车"
          @click="onClickButton"
      />
    </van-goods-action>
  </div>
</template>
<script>
import CreateNewOrder from '@/components/CreateNewOrder.vue';
import ChooseZhubu from '@/components/ChooseZhubu.vue';
import ChooseYongliao from '@/components/ChooseYongliao.vue';
import ChooseDaPei from '@/components/ChooseDaPei.vue';
import {Toast} from 'vant';
import {TypeMaps,fieldData} from "../dict";
export default {
  name: "DesignLTDetail",// 帘头款式
  components: {
    CreateNewOrder,
    ChooseZhubu,
    ChooseDaPei,
    ChooseYongliao
  },
  data() {
    return {
      peibuCofigs:[{name:"中拼"},{name:"内拼"}],
      zhubuList: [],
      dapeiList: [],
      designInfoTemp: {},
      yongLiaoList:[],
      designInfo: {
        list: {},
         qiangkuan:2.5,
        liangao:2.7,
      },
      showDaPeiModal: false,
      showDetailModal: false,
      showDingzhiModal: false,
      customMade: true,
      fieldData:fieldData,
      height: 0,
      imgs: ['imageOne', 'imageTwo', 'imageThree', 'imageFour', 'imageFive'],
      design: {}
    };
  },

  mounted() {
    const height = document.body.clientHeight;
    this.height = height;
     Object.entries(this.AddCartMethods).map((item1)=>this[item1[0]] = item1[1].bind(this))
    this.getStyleData(this.$route.query.id).then((res)=>{
      this.$store.commit("SET_DESIGN_ID", this.design.id || 0 ) // 保存款式id
      this.customMade = this.design.designCategory == "WaiLian" || this.design.designCategory == "LianTou"// 外帘 帘头有定制

    });
    // this.getZhubuList();
  },
  methods: {
    onDaPei() {
      this.showDaPeiModal = true;
    },
    changeDesigns() {
      // 帘头换款
      this.$router.push('./dingzhidesign?id='+this.design.id+'&designType=LianTou')
      // this.$router.replace('/dingzhidesign')
    },
    onCustomDesign() {
      // 帘头定制
      this.$router.push('./dingzhidetail?designId=' + this.design.id + '&customerDesignId=' + this.design.id+'&designType=LianTou');
      // this.$router.replace('/dingzhidesign')
    },
    onClickIcon() {
      this.$router.replace('/cart?activeHeader=chuanglian')
    },
    confirmSelectZhuBuAction() {
      this.showDingzhiModal = false;


    },
    setSelectZhubuModal(v) {
      this.showDingzhiModal = v;
     this.showDaPeiModal =v
    },
    selectItem($item) {

      this.zhubuList = this.zhubuList.map((item) => {
        if ($item.id == item.id) {
          item.active = true
        } else {
          item.active = false
        }
        return item
      })

      this.$store.getters.selZhuBu = $item;
      this.$router.push('./dingzhiproduct?id='+$item.id)
    },
    getZhubuList() {
      this.zhubuList = [{
        src: "http://lian3.suishou.cc/storage/shops/1/designs/eafRBT554cR9RcKs7GEwfiiCq1KWwVVCNmxo3vRO-l.jpg",
        id: "1",
        title: "AD001"
      }, {
        src: "http://lian3.suishou.cc/storage/shops/1/designs/eafRBT554cR9RcKs7GEwfiiCq1KWwVVCNmxo3vRO-l.jpg",
        id: "2",
        title: "AD002"
      }, {
        src: "http://lian3.suishou.cc/storage/shops/1/designs/eafRBT554cR9RcKs7GEwfiiCq1KWwVVCNmxo3vRO-l.jpg",
        id: "3",
        title: "AD003"
      }, {
        title: "AD004",
        src: "http://lian3.suishou.cc/storage/shops/1/designs/eafRBT554cR9RcKs7GEwfiiCq1KWwVVCNmxo3vRO-l.jpg",
        id: "4"
      }]
    },
    selectDapei(item){
      
      this.showDaPeiModal =false;

      this.getStyleData(item.id).then((res)=>{
        this.customMade = this.design.designCategory == "WaiLian" || this.design.designCategory == "LianTou"// 外帘 帘头有定制

      });
      /*this.$router.push({
        path: "/reload",
        query: { path: '/designdetail?id='+item.id }
      });*/
     
    },
    setModalState(v) {
      this.showDetailModal = v
    },
   
    back() {
      history.go(-1)
    },
    /*onDingzhi() {
      this.showDingzhiModal = true;
    },*/
    onClickButton() {
      this.designInfoTemp = {...this.designInfo}
      this.showDetailModal = true;
    },
   
    
    // getStyleData(id) {
    //   this.$http.post("/public/designDetail", {
    //     "designId": id,
    //     "productId": 0,
    //   }).then(res => {
    //     this.imgs = this.imgs.filter((item) => res[item])
    //     this.design = res || {}
    //     this.designInfo.imageOne = res.imageOne;// 款式场景图
    //     this.designInfo.name = res.name;
    //     this.dapeiList = res.collocationDesignList || [];// 大屏列表
    //     this.zhubuList = res.productList || [];// 订单主布列表
    //     this.fieldData.forEach((item) => {
    //       const typeMap =TypeMaps[item.label]||{}
    //       if(typeMap.arrayName){
    //         item.items =res[typeMap.arrayName]||[]
    //         item.items =this.returnCommonObj(item.items,typeMap.idName,typeMap.textName)
    //       }
    //       if(item.label=='面料方向'){
    //         item.items = [{
    //             text: res.zhuBuDesignTypeName,
    //             value: res.zhuBuDesignType
    //           }]
    //       }
    //     })
    //     this.setDefaultData();
    //     this.$http.post("/public/openModes").then(res => {
    //       this.fieldData.forEach((item) => {
    //         switch (item.label) {
    //           case '分片方式':
    //             item.items = res||[]
    //             item.items =this.returnCommonObj(item.items,'optionValue','optionDesc')
    //             break
    //         }
           
    //       })
    //     })
    //     // 购物车模型

    //     document.title = this.design.name
    //   });
    
    // }
  }
};
</script>
<style scoped>
.product-detail .info {

  padding: 10px 20px;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 20px;

}

.product-detail img {
  max-width: 100%;
}

.product-detail .title {
  font-weight: 600;
  font-size:16px;
}

.product-detail .menfu {
  color: #e48f81;
  font-size: 12px;
  margin-top: 10px;
}

.product-detail .desc {
  display: flex;
  font-size: 12px;
  font-size: 12px;
  margin-top: 10px;
  color: #666;
}

.back-icon {
  background: #10111163;
  width: 20px;
  /* padding: 8px 0; */
  border-radius: 100%;
  text-align: center;
  color: #fff;
  font-weight: 600;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
}
</style>
